"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
/* Inspired by: https://codesandbox.io/s/n5nRmZBv4?file=/index.js:227-281 */
var withDynamicTag = function (Component) {
    var bucket = Object.create(null);
    var DynamicTag = function (props) {
        var tag = props.tag;
        // if (typeof tag !== 'string' || !styled.hasOwnProperty(tag)) {
        if (typeof tag !== 'string' || !Object.prototype.hasOwnProperty.call(styled_components_1.default, 'tag')) {
            return react_1.createElement(Component, props);
        }
        if (bucket[tag] === undefined) {
            bucket[tag] = Component.withComponent(tag);
        }
        return react_1.createElement(bucket[tag], props);
    };
    var name = Component.displayName || Component.constructor.name;
    if (name) {
        DynamicTag.displayName = "DynamicTag(" + name + ")";
    }
    return DynamicTag;
};
exports.default = withDynamicTag;
//# sourceMappingURL=dynamicTag.js.map